/* eslint-disable no-unused-vars */
export enum Pages {
  List = 'list',
  Detail = 'detail',
}
